var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormKTCForeverPlan',{attrs:{"is-submitting":_vm.plan.create.isCreating,"group-id":_vm.$route.params.id,"method-id":_vm.$route.params.methodId},on:{"onSubmit":_vm.handleSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }